import { createGlobalKey } from "@aviv-unified-frontend/internal";
export const AIRSHIP_NAMED_USER_STORAGE_KEY = createGlobalKey("airship", "namedUser");
/**
 * Gets the stored Airship named user key from localStorage
 * @returns The named user key if it exists, null otherwise
 */
export const getAirshipNamedUser = () => localStorage.getItem(AIRSHIP_NAMED_USER_STORAGE_KEY);
/**
 * Stores the Airship named user key in localStorage
 * @param namedUserKey - The formatted user key to store
 */
export const setAirshipNamedUser = (namedUserKey) => {
    try {
        localStorage.setItem(AIRSHIP_NAMED_USER_STORAGE_KEY, namedUserKey);
    }
    catch (error) {
        console.warn("[Airship] Failed to set named user in localStorage:", error);
    }
};
/**
 * Removes the Airship named user key from localStorage
 */
export const clearAirshipNamedUser = () => {
    try {
        localStorage.removeItem(AIRSHIP_NAMED_USER_STORAGE_KEY);
    }
    catch (error) {
        console.warn("[Airship] Failed to clear named user from localStorage:", error);
    }
};
